import React from 'react';
import './style.scss';
import {useTranslation} from 'react-i18next'
import Footer from 'src/components/footer';
import Error404 from 'src/assets/img/404.svg';
import ServerError from 'src/assets/img/server-error.svg';
import UnauthenticationError from 'src/assets/img/unauthentication.svg';
import Button, { Type as ButtonType } from 'src/components/button';
import openGlobalAuth from 'src/utils/global-auth';

/**
 * Renders the general Error page - rendered when user is unauthenticated or when there's a major server error or requested
 * page does not exist.
 * 
 * @param {string} - The error type indicating 'generic' or 'unauthentication' or '404'.
 * @returns {JSX.Element} The rendered 404 error page.
 */
function PageError({ errorType }) {
    const { t } = useTranslation();

    const title = t(`${errorType}ErrorTitle`);
    const subtitle = t(`${errorType}ErrorSubtitle`)

    const redirectPath = () => {
        errorType === "404"
          ? (window.location.href = "/profile")
          : openGlobalAuth();
    }

    const errorImage = errorType === '404' ? Error404 : errorType === 'unauthentication' ? UnauthenticationError : ServerError;

    return (
        <div className="page-error">
            <div className="page-error-container">
                <img src={errorImage} alt={`${errorType} Error`} />
                <h1 className='page-error-container--title'>{title}</h1>
                <h2 className='page-error-container--subtitle'>{subtitle}</h2>
                <Button
                    className='page-error-container--button uppercase'
                    type={ButtonType.Primary}
                    uppercase
                    onClick={() =>  redirectPath()}
                >
                    { errorType === '404' ? t('goHome') : t('backToLogin')}
                </Button>
            </div>
            <Footer />
        </div>
    );
}

export default PageError;
